import { createRouter, createWebHistory } from "vue-router";
import Inicio from "../views/Inicio.vue";
import Contratos from "../views/Contratos.vue";
import Confirmar from "../views/Confirmar.vue";
import PageNotFound from "../views/PageNotFound.vue";

const routes = [
  {
    path: "/",
    name: "Inicio",
    component: Inicio,
  },
  {
    path: "/contratos",
    name: "Contratos",
    component: Contratos,
  },
  {
    path: "/confirmar",
    name: "Confirmar",
    component: Confirmar
  },
  {
    // path: "*",
    path: "/:catchAll(.*)",
    name: "PageNotFound",
    component: PageNotFound,
    meta: {
      requiresAuth: false
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
